export default function(selectedStatus) {
  return ($scope, $uibModalInstance) => {
    'ngInject';

    const ExceedingBench = '//d4znxc3tx8unj.cloudfront.net/EB.png';
    const FallingBehind = '//d4znxc3tx8unj.cloudfront.net/FB.png';
    const InDanger = '//d4znxc3tx8unj.cloudfront.net/ID.png';
    $scope.status = selectedStatus;
    $scope.calculationImages = {
      'Exceeding Benchmark': ExceedingBench,
      'Behind Benchmark': FallingBehind,
      'At Risk': InDanger
    };
    $scope.statusDesDict = {
      'Exceeding Benchmark':
        '<p> Individuals who are exceeding the benchmark are ahead of where they need to be based upon the number of hours they have at whatever point they’re at in their CPE renewal cycle.</p> <p>This is based on an average number of hours they need to earn to hit their cycle requirements and how much time they have to do so.  You can imagine this as a line that starts at “0” on the first day of their cycle and extends to the required number of hours on the last day of their cycle.</p>',
      'Behind Benchmark':
        '<p>Individuals who are behind the benchmark aren’t in danger yet but should aim to catch up to the benchmark as soon as they’re able.  If they have courses coming up soon they should be able to catch up quickly.</p> <p>This is based on an average number of hours they need to earn to hit their cycle requirements and how much time they have to do so.  You can imagine this as a line that starts at “0” on the first day of their cycle and extends to the required number of hours on the last day of their cycle.<p>',
      'At Risk':
        '<p>Individuals who are in danger are far enough behind their benchmark for this time in their cpe cycle that they should be concerned about meeting their license requirements.</p> <p>This is based on an average number of hours they need to earn to hit their cycle requirements and how much time they have to do so.  You can imagine this as a line that starts at “0” on the first day of their cycle and extends to the required number of hours on the last day of their cycle.</p>'
    };
    $scope.colorDict = {
      'Exceeding Benchmark': 'primary',
      'Behind Benchmark': 'warning',
      'At Risk': 'danger'
    };
    $scope.close = () => {
      $uibModalInstance.dismiss('cancel');
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/dashboard/seeCalculationInfoController.js